import "core-js/modules/es.array.push.js";
import FootLanguage from "../components/Layout/footLanguage.vue";
import { encrypt } from "@/libs/rsa";
import SendMessage from "../components/SendMessage.vue";
import { restPass, restPassByEmail } from "../service/user";
import { passwordRulesValidation } from "@/utils/vueTemplateFunction";
import { rsa } from "../libs/rsa";
import passwordInput from "@/components/Common/passwordInput.vue";
export default {
  components: {
    FootLanguage,
    SendMessage,
    passwordInput
  },
  data() {
    return {
      langLo: localStorage.getItem("language") ? localStorage.getItem("language") : "",
      weakIntensity: false,
      moderateIntensity: false,
      highIntensity: false,
      accountType: "MOBILE",
      rules: {
        pw: [{
          required: true,
          message: $t("c2r1q94", "密码必填"),
          trigger: "blur"
        }, {
          validator: passwordRulesValidation,
          trigger: "blur,change"
        }]
      },
      form: {
        pw: "",
        email: "",
        mobile: "",
        verificationCode: "",
        mobileAreaCode: "+86"
      }
    };
  },
  computed: {},
  watch: {
    accountType() {
      this.$refs.sendMessage.clean();
      this.$refs.sendMessage.clearVerificationCode();
      // this.$refs["form"].resetFields();
    }
  },
  methods: {
    goToOther(name) {
      this.$router.push({
        name
      });
    },
    changePassword(e) {
      const value = e.target.value;

      // 判断密码强度
      let hasUpper = /[A-Z]/.test(value);
      let hasLower = /[a-z]/.test(value);
      let hasNumber = /\d/.test(value);
      let hasSymbol = /[^A-Za-z0-9]/.test(value);
      let charTypes = [hasUpper, hasLower, hasNumber, hasSymbol].filter(Boolean).length;
      if (value.length >= 8) {
        setTimeout(() => {
          this.weakIntensity = charTypes === 1;
          this.moderateIntensity = charTypes === 2 || charTypes === 3;
          this.highIntensity = charTypes === 4;
        }, 50);
      } else {
        this.weakIntensity = false;
        this.moderateIntensity = false;
        this.highIntensity = false;
      }
    },
    async submit() {
      this.$refs.sendMessage.validate(async valid => {
        let valid2 = await this.$refs.form.validate();
        if (valid && valid2) {
          const {
            pw,
            mobile,
            verificationCode: validateCode,
            email,
            mobileAreaCode
          } = this.form;
          const enc_mobile = rsa({
            mobile
          }, "mobile");
          const enc_email = rsa({
            email
          }, "email");
          const password = encrypt(pw);
          let res = null;
          if (this.accountType === "MOBILE") {
            res = await restPass({
              ...enc_mobile,
              validateCode,
              password,
              mobileAreaCode
            });
          } else {
            res = await restPassByEmail({
              ...enc_email,
              validateCode,
              password
            });
          }
          if (res.data && res.data.result == 0) {
            this.$Message.success({
              content: $t("b8aq16b", "修改成功,跳转到登录页")
            });
            setTimeout(() => {
              this.$router.push("/login");
            }, 2000);
          } else {
            res = null;
          }
        }
      });
    },
    cancle() {
      this.$router.push("/login");
    }
  }
};